const pre = '/bcos/chain/';

export default {
    path: '/bcos/chain',
    title: '链管理',
    header: '',
    icon: 'md-link',
    children: [
        {
            path: `${pre}group`,
            title: '节点管理',
        },
    ]
}
